//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState } from 'react';

// === API ===
import { sendMessageData } from 'api/prokey/prokey.websocket';

// === STYLES ===
import { useTheme } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
} from '@mui/material';

// === COMPONENTS
import {Spacer} from 'components/Spacer';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

//#endregion

const settings_default = {
  allowManualTaskSelection: false,
}

//-----------------------------------------------------------------
export default function BulkEditUsersDialog(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { users, roles = [] } = props;

  const theme = useTheme();


  const [ company   , setCompany  ] = useState( '' );
  const [ settings  , setSettings ] = useState( { ...settings_default } );

  const [ _roles       , setRoles       ] = useState( {} );
  const [ role_add_anchor    , setAnchorAdd    ] = useState( null );
  const [ role_remove_anchor , setAnchorRemove ] = useState( null );
  const role_add_open    = Boolean(role_add_anchor)
  const role_remove_open = Boolean(role_remove_anchor)

  const [ infos       , setInfos      ] = useState( {} );
  const [ info_anchor , setAnchorInfo ] = useState( null );
  const info_open = Boolean(info_anchor)

  const [ _settings       , set_Settings       ] = useState( {} );
  const [ _settings_anchor , setAnchor_Settings ] = useState( null );
  const _settings_open = Boolean(_settings_anchor)

  const [ show_alert , setShowAlert ] = useState( false );
  const [ alert_text , setAlertText ] = useState( '' );

  const role_options = roles.map((role) => {
    return { label: role.RoleName, value: role.id.toString() };
  });

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      width  : '100%',
      height : '100%',
    },
    dialog : {

      width  : '1000px',
      height : '100%',
    }
  }

  const
    CONTAINER = {
      style : _styles.container,
    },
    DIALOG = {
      sx             : _styles.container,
      open           : props.showDialog,
      onClose        : handleClose,
      ariaLabelledby : 'form-dialog-title'
    },
    COMPANY = {
      id           : 'company',
      label        : 'Company',
      value        :  company,
      type         : 'text',
      margin       : 'dense',
      autoComplete : 'off',
      fullWidth    : true,
      autoFocus    : true,
      onChange     : (e) => { setCompany(e.target.value); },
    },
    TASK_SELECTION = {
      checked: settings.allowManualTaskSelection,
      onChange: (e) => {
        const temp = { ...settings };
        temp.allowManualTaskSelection = !settings.allowManualTaskSelection;
        setSettings( temp );
      },
    },
    BUTTON_CLOSE = {
      color    : 'primary'   ,
      onClick  : handleClose ,
      children : [ 'Close' ] ,
    },
    BUTTON_SUBMIT = {
      color    : 'primary'    ,
      onClick  : handleSubmit ,
      children : [ 'Submit' ] ,
    };

  //#endregion

  //#region [EFFECT]



  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleClick_InfoAdd(event) {
    //-----------------------------------------------------------------
    setAnchorInfo(event.currentTarget);
  };

  //-----------------------------------------------------------------
  function handleClose_InfoAdd() {
    //-----------------------------------------------------------------
    setAnchorInfo(null);
  };
  //-----------------------------------------------------------------
  function handleRemove_Info(value) {
    //-----------------------------------------------------------------
    const infos_temp = { ...infos };
    delete infos_temp[value];
    setInfos(infos_temp);
  };

  //-----------------------------------------------------------------
  function handleAdd_Info(value) {
    //-----------------------------------------------------------------
    const infos_temp = { ...infos };
    infos_temp[value] = 1;
    setInfos(infos_temp);
  };

  // === SETTINGS

  //-----------------------------------------------------------------
  function handleClick_SettingAdd(event) {
    //-----------------------------------------------------------------
    setAnchor_Settings(event.currentTarget);
  };

  //-----------------------------------------------------------------
  function handleClose_SettingAdd() {
    //-----------------------------------------------------------------
    setAnchor_Settings(null);
  };
  //-----------------------------------------------------------------
  function handleRemove_Setting(value) {
    //-----------------------------------------------------------------
    const settings_temp = { ..._settings };
    delete settings_temp[value];
    set_Settings(settings_temp);
  };

  //-----------------------------------------------------------------
  function handleAdd_Setting(value) {
    //-----------------------------------------------------------------
    const settings_temp = { ..._settings };
    settings_temp[value] = 1;
    set_Settings(settings_temp);
  };

  // === ROLES

  //-----------------------------------------------------------------
  function handleRemove_RoleAdd(role_name, role_id_raw) {
    //-----------------------------------------------------------------
    const role_id = parseInt(role_id_raw);

    if (isNaN(role_id) ) return;

    const roles_temp = { ..._roles };
    delete roles_temp[role_id_raw];
    setRoles(roles_temp);
  }

  //-----------------------------------------------------------------
  function handleRemove_RoleRemove(role_name, role_id_raw) {
    //-----------------------------------------------------------------
    const role_id = parseInt(role_id_raw);

    if ( isNaN(role_id) ) return;

    const roles_temp = { ..._roles };
    delete roles_temp[role_id_raw];
    setRoles(roles_temp);
  }

  //-----------------------------------------------------------------
  function handleClick_RoleAdd(event) {
    //-----------------------------------------------------------------
    setAnchorAdd(event.currentTarget);
  };

  //-----------------------------------------------------------------
  function handleClick_RoleRemove(event) {
    //-----------------------------------------------------------------
    setAnchorRemove(event.target);
  };

  //-----------------------------------------------------------------
  function handleClose_RoleAdd() {
    //-----------------------------------------------------------------
    setAnchorAdd(null);
  };

  //-----------------------------------------------------------------
  function handleClose_RoleRemove() {
    //-----------------------------------------------------------------
    setAnchorRemove(null);
  };

  //-----------------------------------------------------------------
  function handleAdd_RoleAdd(role_id_raw) {
    //-----------------------------------------------------------------
    const role_id = parseInt(role_id_raw);

    if ( isNaN(role_id) ) return;

    const roles_temp = { ..._roles };
    roles_temp[role_id_raw] = 1;
    setRoles(roles_temp);
  };
  //-----------------------------------------------------------------
  function handleAdd_RoleRemove(role_id_raw) {
    //-----------------------------------------------------------------
    const role_id = parseInt(role_id_raw);

    if ( isNaN(role_id) ) return;

    const roles_temp = { ..._roles };
    roles_temp[role_id_raw] = -1;
    setRoles(roles_temp);
  };

  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  async function editUsers() {
    //-----------------------------------------------------------------
    try {
  
      // Submit data to backend api
      let user_data = {
        roles : {
          add : [],
          remove : [],
        },
        settings : {

        },
      };

      Object.keys( _roles ).forEach( role => {
        if( _roles[role] === 1 ) user_data.roles.add   .push( role )
        else                     user_data.roles.remove.push( role )
      });

      if( !!infos['company']         ) user_data.company = company;
      if( !!_settings['task-select'] ) user_data.settings.allowManualTaskSelection = settings.allowManualTaskSelection;
      
      sendMessageData( 'USER-UPDATE-REQUEST-BULK', { ids: users, data: user_data } );
  
      return true;
    } catch (error) {
      console.log( error );
    }
  }

  //-----------------------------------------------------------------
  function resetData() {
    //-----------------------------------------------------------------
    setCompany ( '' );
    setRoles( {} );
    setInfos( {} );
    setSettings( { ...settings_default } );
    set_Settings( {} );
  };

  //-----------------------------------------------------------------
  function handleSubmit( event ) {
    //-----------------------------------------------------------------
    editUsers();
    resetData();
    props.setShowDialog(false);
  };

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    props.setShowDialog(false);
    handleDismissAlert();
    resetData();
  };

  //-----------------------------------------------------------------
  function handleDismissAlert() {
    //-----------------------------------------------------------------
    setShowAlert(false);
    setAlertText('');
  };

  //#endregion

  //#region [DISPLAY]

  // ------------------------------------------------------
  // ALERT

  //-----------------------------------------------------------------
  function handleErrClose(event, reason) {
    //-----------------------------------------------------------------
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };

  //-----------------------------------------------------------------
  function displayError() {
    //-----------------------------------------------------------------
    return (
      <Snackbar open={show_alert} autoHideDuration={6000} onClose={handleErrClose}>
        <Alert onClose={handleErrClose} severity='error'>
          {alert_text}
        </Alert>
      </Snackbar>
    );
  };

  // ------------------------------------------------------
  // MODAL

  // I'm sorry
  //-----------------------------------------------------------------
  function displayAddUserModal() {
    //-----------------------------------------------------------------
    if( !props.showDialog ) return null;
    return (
      <div { ...CONTAINER } >
        <Dialog { ...DIALOG } >
          <DialogTitle id='form-dialog-title' variant='primary' sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >Edit Users</DialogTitle>
          <DialogContent sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >
              <Menu id='info-add' anchorEl={info_anchor} keepMounted open={info_open} onClose={handleClose_InfoAdd} >
                {[{label: 'Company', value: 'company' }].filter( x=>!infos[x.value]).map((option) => {
                  return (
                    <MenuItem key={option.value} onClick={() => handleAdd_Info(option.value)}>
                      {option.label}
                    </MenuItem>
                  );
                })}
              </Menu>
            <div style={{display:'flex'}}><DialogContentText>Enter user information</DialogContentText><Spacer/><button style={{height: '2rem'}} onClick={handleClick_InfoAdd}>+</button></div>
            {[{label: 'Company', value: 'company' }].filter(x=>!!infos[x.value]).map((option) => {
              if( option.value === 'company') return <div style={{display:'flex', alignItems: 'center'}}><button style={{height: '2rem', width: '2rem'}} onClick={()=>handleRemove_Info('company')}>-</button><Spacer /><TextField { ...COMPANY    } /></div>
              else return null
            })}
            <h3>Roles:</h3>
            <div style={{ display: 'flex', gridTemplateColumns: '1fr 1fr', gridTemplateRows: 'auto 1fr', gridGap: '1rem', width: '400px', height: '300px', overflow:'hidden'}}>
              {/**ROLE ADD */}
              <div style={{display: 'grid', gridTemplateRows: 'auto 1fr', height: '100%', width: '50%', overflow:'hidden'}}>
                <div style={{display: 'flex', alignItems:'center'}}>
                  <h4>Add</h4>
                  <Spacer push_right />
                  <button style={{height: '2rem'}} onClick={handleClick_RoleAdd}>+</button>
                </div>
                <div key='role-add' style={{ border: 'solid 2px ' + theme.palette.primary.main, height: '100%', padding: '1rem', overflow:'auto', scrollbarWidth:'thin'}}>
                  {role_options.filter(x=>_roles[x.value]===1).map((option) => {
                    return (
                      <MenuItem key={option.value} onClick={() => handleRemove_RoleAdd(option.label, option.value)}>
                        {option.label}
                      </MenuItem>
                    );
                  })}
                </div>
                <Menu id='role-add' anchorEl={role_add_anchor} keepMounted open={role_add_open} onClose={handleClose_RoleAdd} >
                  {role_options.filter(x=>!_roles[x.value]).map((option) => {
                    return (
                      <MenuItem key={option.value} onClick={() => handleAdd_RoleAdd(option.value)}>
                        {option.label}
                      </MenuItem>
                    );
                  })}
                </Menu>
              </div>
              {/**ROLE REMOVE */}
              <div style={{display: 'grid', gridTemplateRows: 'auto 1fr', height: '100%', width: '50%', overflow:'hidden'}}>
                <div style={{display: 'flex', height: '100%', alignItems:'center'}}>
                  <h4>Remove</h4>
                  <Spacer push_right />
                  <button style={{height: '2rem'}} onClick={handleClick_RoleRemove}>+</button>
                </div>
                <div key='role-remove' style={{border: 'solid 2px ' + theme.palette.primary.main, height: '100%', padding: '1rem', overflow:'auto', scrollbarWidth:'thin'}}>
                  {role_options.filter(x=>_roles[x.value]===-1).map((option) => {
                    return (
                      <MenuItem key={option.value} onClick={() => handleRemove_RoleRemove(option.label, option.value)}>
                        {option.label}
                      </MenuItem>
                    );
                  })}
                </div>
                <Menu id='role-remove' anchorEl={role_remove_anchor} keepMounted open={role_remove_open} onClose={handleClose_RoleRemove}>
                  {role_options.filter(x=>!_roles[x.value]).map((option) => {
                    return (
                      <MenuItem key={option.value} onClick={() => handleAdd_RoleRemove(option.value)}>
                        {option.label}
                      </MenuItem>
                    );
                  })}
                </Menu>
              </div>
            </div>

            <div style={{display:'flex', alignItems: 'center'}}><h3>Settings:</h3><Spacer /><button style={{height: '2rem'}} onClick={handleClick_SettingAdd}>+</button></div>
            
            <Menu id='settings-add' anchorEl={_settings_anchor} keepMounted open={_settings_open} onClose={handleClose_SettingAdd} >
              {[{label: 'Task Select', value: 'task-select' }].filter( x=>!_settings[x.value]).map((option) => {
                return (
                  <MenuItem key={option.value} onClick={() => handleAdd_Setting(option.value)}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </Menu>
            {[{label: 'Task Select', value: 'task-select' }].filter(x=>!!_settings[x.value]).map((option) => {
              if( option.value === 'task-select') return (
                <div style={{display:'flex', alignItems: 'center'}}>
                  <button style={{height: '2rem', width: '2rem'}} onClick={()=>handleRemove_Setting('task-select')}>-</button>
                  <Spacer />
                  <FormControlLabel 
                    label   = "Allow Manual Task Selection" 
                    control = { <Checkbox { ...TASK_SELECTION } /> }
                  />
                </div>
              )
              else return null
            })}
           
          </DialogContent>
          <DialogActions sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }} >
            <Button { ...BUTTON_CLOSE  } />
            <Button { ...BUTTON_SUBMIT } />
          </DialogActions>
        </Dialog>
        {displayError()}
      </div>
    );
  }

  //#endregion

  return displayAddUserModal();
}